// extracted by mini-css-extract-plugin
export var box = "_v-2";
export var checkboxControl = "_v-0";
export var checkboxRow = "_v-a";
export var checked = "_v-3";
export var descriptionSpacer = "_v-c";
export var disabled = "_v-4";
export var icon = "_v-8";
export var input = "_v-1";
export var labelSpacer = "_v-b";
export var large = "_v-7";
export var medium = "_v-6";
export var small = "_v-5";
export var text = "_v-9";